import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// import App from "./App";
import "./index.css";
import { OktaAuth } from "@okta/okta-auth-js";
// import { localOktaConfig } from "./config";
// import { labcorpOktaConfig } from "./config";

function Header() {
  return (
    <header className="main-header">
      <div className="header-content"></div>
    </header>
  );
}
function Footer() {
  return (
    <footer className="main-footer">
      <div className="footer-content">
        &copy; {new Date().getFullYear()} LabCorp. All rights reserved.
      </div>
    </footer>
  );
}

(async () => {
  const res = await fetch("/api/env");
  const app_env = await res.text();
  window.APP_ENV = app_env;
  console.log("App environment:", app_env);

  // Fetch Okta config from server (uses Code Engine env vars at runtime)
  let oktaConfig;
  let configSource = "unknown";
  try {
    const configRes = await fetch("/api/okta-config");
    if (!configRes.ok) {
      throw new Error(`Server returned ${configRes.status}`);
    }
    oktaConfig = await configRes.json();
    configSource = "server (Code Engine env vars)";
  } catch (error) {
    throw new Error(
      "Okta configuration could not be loaded. Please contact support."
    );
  }

  const oktaAuth = new OktaAuth({
    ...oktaConfig,
    redirectUri: `${window.location.origin}/login/callback`,
    tokenManager: {
      autoRenew: true,
      autoRemove: true,
    },
  });

  const { default: App } = await import("./App");

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <BrowserRouter>
      <main className="main-body">
        <App oktaAuth={oktaAuth} />
      </main>
    </BrowserRouter>
  );
})();
